import { render, staticRenderFns } from "./configNew.vue?vue&type=template&id=585e181a&scoped=true&"
import script from "./configNew.vue?vue&type=script&lang=js&"
export * from "./configNew.vue?vue&type=script&lang=js&"
import style0 from "./configNew.vue?vue&type=style&index=0&id=585e181a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e181a",
  null
  
)

export default component.exports